(function () {
  document.querySelectorAll('[data-gs-ad-faq]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        details.parentElement
          .querySelectorAll('[data-gs-ad-faq][open]')
          .forEach(function (other) {
            if (other !== details) other.open = false;
          });
      }
    });
  });

  document.querySelectorAll('[data-gs-ad-load-comments]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var root = btn.closest('.gs-ad-page') || document;
      root.querySelectorAll('.gs-ad-comment--hidden').forEach(function (el) {
        el.classList.remove('gs-ad-comment--hidden');
      });
      btn.hidden = true;
    });
  });

  document.querySelectorAll('[data-gs-ad-selftest]').forEach(function (root) {
    var resultEl = root.querySelector('[data-gs-ad-selftest-result]');
    var resultText = root.querySelector('[data-gs-ad-selftest-result-text]');
    if (!resultEl || !resultText) return;

    var checks = root.querySelectorAll('[data-gs-ad-selftest-check]');
    var total = checks.length;
    var lowMax = parseInt(root.dataset.lowMax || '2', 10);
    var midMax = parseInt(root.dataset.midMax || '4', 10);
    var msgLow = root.dataset.msgLow || '';
    var msgMid = root.dataset.msgMid || '';
    var msgHigh = root.dataset.msgHigh || '';

    function formatMsg(template, count) {
      return template
        .replace(/%COUNT%/g, String(count))
        .replace(/%TOTAL%/g, String(total));
    }

    function update() {
      var checked = root.querySelectorAll(
        '[data-gs-ad-selftest-check][aria-pressed="true"]'
      ).length;

      if (checked === 0) {
        resultEl.hidden = true;
        resultEl.className = 'gs-ad-selftest-result';
        resultText.textContent = '';
        return;
      }

      var tier = 'high';
      if (checked <= lowMax) tier = 'low';
      else if (checked <= midMax) tier = 'mid';

      resultEl.hidden = false;
      resultEl.className =
        'gs-ad-selftest-result gs-ad-selftest-result--' + tier + ' is-visible';

      var msg = msgHigh;
      if (tier === 'low') msg = msgLow;
      else if (tier === 'mid') msg = msgMid;

      resultText.textContent = formatMsg(msg, checked);
    }

    checks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        btn.classList.toggle('is-checked', !pressed);
        update();
      });
    });
  });

  document.querySelectorAll('[data-gs-ad-countdown]').forEach(function (el) {
    var total =
      parseInt(el.dataset.minutes || '14', 10) * 60 +
      parseInt(el.dataset.seconds || '37', 10);
    if (total <= 0) return;

    function fmt(s) {
      var m = Math.floor(s / 60);
      var sec = s % 60;
      return (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    el.textContent = fmt(total);
    setInterval(function () {
      if (total > 0) {
        total--;
        el.textContent = fmt(total);
      }
    }, 1000);
  });
})();
